<template>
    <v-card :dark="dark" style="height: 100%" class="course-card" :class="{'bordered': !dark}">
        <div :style="`background-image: url(${course.image_url}); height: ${phoneOnly ? 200 : (short ? 170 : 185)}px; background-size: cover; background-position: center; width: 100%`" @click="$router.push({name: 'course', params: {id: course.id}})" v-ripple class="e-link">
            <div class="pa-3 d-flex justify-space-between">
            </div>
        </div>
        <div class="px-4 py-3">
            <div class="mb-1 details-text muted--text">
                {{gradesComputed}}
                
                <span v-if="course.pay_type === 'course' && platform !== 'ios'">
                    |
                    <b v-if="course.price === 0" class="secondary--text">Free</b>
                    <b v-else class="secondary--text">{{moneyFormat(course.price, true)}}</b>
                </span>

                <v-chip v-if="course.featured" label outlined small dark color="secondary" class="ms-1" style="height: 20px; padding: 0 6px;">
                    <v-icon size="15" class="me-1">mdi-star</v-icon>
                    <span>Featured</span>
                </v-chip>
            </div>
            <div class="course-title" :class="{'sm-title': short}">
                <router-link :class="{'strong-text--text': !dark, 'white--text': dark}" style="text-decoration: none" :to="{name: 'course', params: {id: course.id}}">
                    {{course.name}}
                </router-link>
            </div>
            <div class="mt-5">
                <div class="d-flex justify-space-between">
                    <div class="small-text d-flex align-center">
                        <v-icon color="secondary" small class="me-1">mdi-play-circle-outline</v-icon>
                        {{unitFormat(course.lectures_count, 'Lecture', '2 Lectures', 'Lectures')}}
                    </div>
                    <div v-if="course.users_count" class="small-text d-flex align-center">
                        <v-icon color="secondary" small class="me-1">mdi-account-group-outline</v-icon>
                        {{unitFormat(course.users_count, 'Student', '2 Students', 'Students')}}
                    </div>
                </div>
            </div>
        </div>
        <v-card-text v-if="!short" class="pt-0 px-4">
            <div class="categories">
                <v-chip v-for="category in course.categories" color="surface2" :key="category.id" label small class="me-2 mb-1">{{category.name}}</v-chip>
            </div>
            <!-- <div class="teachers-wrapper d-flex align-center mt-2">
                <v-chip v-for="teacher in course.teachers" small :key="'teacher-' + teacher.id" color="grey lighten-4" class="font-weight-medium px-1 pe-3 me-2">
                    <v-avatar class="me-2" style="min-width: 20px!important; width: 20px!important; height: 20px!important;">
                        <v-img :src="teacher.avatar"></v-img>
                    </v-avatar>
                    <span>{{teacher.name}}</span>
                </v-chip>
            </div> -->
        </v-card-text>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        course: {},
        short: {type: Boolean, default: false},
        dark: {type: Boolean, default: false}
    },
    components: {},
    data(){
        return {
            
        }
    },
    computed: {
        free(){
            return this.course && this.course.pay_type === 'course' && this.course.free;
        },
        gradesComputed(){
            const grades = this.course.grades;
            let text = '';
            grades.forEach((grade, i)=>{
                text += grade.name;
                if (i !== grades.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        categoriesComputed(){
            const categories = this.course.categories;
            let text = '';
            categories.forEach((category, i)=>{
                text += category.name;
                if (i !== categories.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
.course-card.v-card{
    transition: 0.1s ease all;
    border-radius: 6px!important;
    overflow: hidden;
    // box-shadow: 1px 2px 4px rgba(0,0,0, .1)!important;
    &:hover{
        // box-shadow: 1px 3px 9px 2px rgba(0,0,0, .1)!important;
    }

    .course-title {
        text-overflow: ellipsis!important;
        overflow: hidden!important;

        line-height: 1.4;
        font-size: 1.15rem;
        &.sm-title{
            font-size: 1.08rem;

        }

        a{
            text-decoration: none;
            word-break: normal;
            white-space: nowrap;
            text-overflow: ellipsis!important;
            overflow: hidden!important;
        }
    }
}
</style>